import PhotoDotsIndicator from '../src/PhotoDotsIndicator/PhotoDotsIndicator.tsx';
export default PhotoDotsIndicator;
